import React, { useEffect, useState } from 'react';

import { Nota, Opcoes } from '../widgets/Widgets.jsx';

const OPCOES = [
  { value: 'sim_acompanhamento', label: 'Sim, com acompanhamento' },
  { value: 'sim_sem_acompanhamento', label: 'Sim, sem acompanhamento' },
  { value: 'nao', label: 'Não' },
  { value: 'prefiro_nao_informar', label: 'Prefiro não responder' },
];

export default function StepWeightLossMedication({ answers, setCanProceed, setStepData }) {
  const [resposta, setResposta] = useState(() => answers?.WEIGHT_LOSS_MEDICATION || '');

  useEffect(() => {
    const valido = OPCOES.some(({ value }) => value === resposta);
    setCanProceed(valido);
    setStepData(valido ? { WEIGHT_LOSS_MEDICATION: resposta } : null);
  }, [resposta, setCanProceed, setStepData]);

  return (
    <>
      <Opcoes
        opcoes={OPCOES}
        valor={resposta}
        onSelecionar={setResposta}
        numeradas={false}
        nome="Uso de medicamento para emagrecimento"
      />
      <Nota>
        É um dado de saúde. Ele serve só para reforçar cuidados na alimentação — não muda
        medicamento, dose ou prescrição.
      </Nota>
    </>
  );
}
